// extracted by mini-css-extract-plugin
export default {"filterTags":"S7cHItZ","colorTileForTag":"MWNQytD","colorTileForTagWrapper":"zctOxnG","displayText":"xz0rhse","tagItem":"U09voa0","filterTagsEnable":"cHWT88r"};